import withLabel from '../../wrappers/LabelledInput/withLabel';
import SelectListInput from '../../atoms/SelectListInput/SelectListInput';

const SelectList = withLabel(SelectListInput);

export default SelectList;
